module.exports = __webpack_public_path__ + "static/media/Crecimiento-del-Comercio-Mundial-2013-2020.e622c8df.pdf";